import { render, staticRenderFns } from "./AppPage.vue?vue&type=template&id=456435f2&scoped=true"
import script from "./AppPage.vue?vue&type=script&lang=js"
export * from "./AppPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456435f2",
  null
  
)

export default component.exports